import { css } from '@emotion/css'
import { Button, Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import PrimaryCircularProgress from '../../../../components/ProgressBackdrop/compoenents/PrimaryCircularProgress'
import { getComp } from '../../../../utils/utils/DI'
import { adminRequestsCheckboxStore } from '../../pages/AdminRequestsPage'
import NewDealerSelect from '../RequestDetails/AssignToDealerView/utils/NewDealerSelect'
import { useNewAssignDealerDrawer } from './hooks/useNewAssignDealerDrawer'

function NewAssignDealerDrawer() {
  const dealersStore = getComp('DealersStore')
  const {
    dealer,
    setDealer,
    onClose,
    dealers,
    onAssignDealer,
    isLoading,
    isPending,
    isOpen,
    data,
  } = useNewAssignDealerDrawer()

  return (
    // @ts-ignore
    <RightDrawer
      open={isOpen}
      onClose={onClose}
      titleComp={
        <Box className={'fx-col'}>
          <Typography variant={'subtitle1'} color={'common.white'}>
            <FormattedMessage id={'Заявок выбрано'} />:{' '}
            {adminRequestsCheckboxStore.selectedIds.length}
          </Typography>
          <Typography variant={'body1'} color={'#8FBFF6'}>
            <FormattedMessage id={'Назначить дилера'} />
          </Typography>
        </Box>
      }
    >
      {isLoading ? (
        <Stack
          justifyContent={'center'}
          alignItems={'center'}
          width={'100%'}
          height={'100%'}
        >
          <PrimaryCircularProgress color='inherit' thickness={1} />
        </Stack>
      ) : (
        <Box
          mx={2}
          //   @ts-ignore
          className={classNames('fx fx-col', css({ flex: '1 1 auto' }))}
        >
          <NewDealerSelect
            dealer={dealer}
            setDealer={setDealer}
            collection={dealers}
            availableRequestData={data}
          />
        </Box>
      )}
      <Box width={1} mt={2} p={2} pb={3}>
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          onClick={onAssignDealer}
          disabled={!dealer}
          loading={isPending}
        >
          <FormattedMessage id={'Назначить'} />{' '}
          {dealersStore.getDealer(dealer)?.displayName}
          {dealer && ` (${data?.[dealer]?.length})`}
        </Button>
      </Box>
    </RightDrawer>
  )
}

export default observer(NewAssignDealerDrawer)
